function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 .556C6.127.556.556 6.127.556 13c0 6.873 5.571 12.444 12.444 12.444 6.873 0 12.444-5.571 12.444-12.444A12.444 12.444 0 0013 .556zm4.444 8.888c1.45 0 2.633 1.17 2.667 2.636 0 1.49-1.194 2.698-2.667 2.698-1.472 0-2.666-1.208-2.666-2.698.034-1.466 1.218-2.636 2.666-2.636zM4.111 12.111c.038-2.489 2.026-4.477 4.445-4.444 2.413-.02 4.394 1.96 4.444 4.444-.044 2.487-2.029 4.47-4.444 4.444-2.416.027-4.4-1.957-4.445-4.444zm0 5.473a6.914 6.914 0 013.937-1.022c3.847 0 5.788 2.3 6.73 5.112-.737.147-1.49.219-2.243.215-3.424-.002-6.606-1.66-8.424-4.305zm12.01 4.25a11.033 11.033 0 00-1.336-2.62A8.262 8.262 0 0013 17.283c.948-1.613 2.786-2.583 4.744-2.501 1.583-.059 3.108.563 4.145 1.69-1.056 2.47-3.14 4.427-5.769 5.416v-.054z",
  fill: "#E1E9F0",
  fillRule: "evenodd"
});

var SvgPeople = function SvgPeople(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), _ref);
};

export default SvgPeople;